/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC } from 'react';
import { TEXT_COLOR_LIGHT } from '../../../typings';
import QSButton from '../../atoms/button';
import QSTypography from '../../atoms/typography';

interface ErrorContainerProps {
  error?: string;
}

const ErrorContainer: FC<ErrorContainerProps> = ({
  error = 'Something went wrong',
}) => {
  return (
    <div
      css={css`
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          font-family: 'Avenir Next';
          font-size: 16px;
          font-weight: 400;
          line-height: 1.3;
          text-align: center;
          color: ${TEXT_COLOR_LIGHT};
        `}
      >
        <QSTypography
          css={css`
            font-size: 74px;
            font-weight: 800;
          `}
        >
          OOPS!
        </QSTypography>
        <QSTypography
          css={css`
            font-size: 18px;
          `}
        >
          {error}
        </QSTypography>
      </div>
      <QSButton
        variant="text"
        onClick={() => window.location.reload()}
        css={css`
          background: none;
        `}
      >
        RELOAD PAGE
      </QSButton>
    </div>
  );
};

export default ErrorContainer;
